import type { BlogPillar } from "./types";

export const BLOG_PILLARS: readonly BlogPillar[] = [
    "comparison",
    "pain-point",
    "ai",
    "multilingual",
    "local",
    "business",
];

export const BLOG_PILLAR_LABELS: Record<BlogPillar, string> = {
    comparison: "Comparisons",
    "pain-point": "Pain points",
    ai: "AI",
    multilingual: "Multilingual",
    local: "Local",
    business: "Business",
};
